import type { AppDispatch, RootState } from "app/store";

import { selectPeekRedo, selectPeekUndo } from "./selectors";
import { undoRedoActions } from "./slice";

/** Run the top undo entry. False when the stack is empty. */
export function runUndo(dispatch: AppDispatch, state: RootState): boolean {
    const nextUndo = selectPeekUndo(state);
    if (nextUndo === undefined) {
        return false;
    }
    nextUndo.undoCallback();
    dispatch(undoRedoActions.undo());
    return true;
}

/** Run the top redo entry. False when the stack is empty. */
export function runRedo(dispatch: AppDispatch, state: RootState): boolean {
    const nextRedo = selectPeekRedo(state);
    if (nextRedo === undefined) {
        return false;
    }
    nextRedo.redoCallback();
    dispatch(undoRedoActions.redo());
    return true;
}
